/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
class s{constructor(s,t,e){this.material=s,this.geometry=t,this.meta=e}dispose(){this.material.dispose(),this.geometry.dispose()}}export{s as Renderable};
